import _ from "lodash";
import React from "react";
import update from "immutability-helper";
import {
  setToastMsg,
  setCurrentPageTitle,
} from "Login/modules/LoginModule/LoginActions";
import { TeacherMenu } from "Teacher/TeacherMenu";
import client from "lib/apolloClient/client";
import { upsertUserFieldsMutation } from "modules/CommonMutations";
import { toggleActionLoading } from "modules/Services/ServicesActions";
import { getUserThirdPartyRedirectionConfigsQuery } from "Teacher/modules/TeacherQuery";
import {
  getCourseDetailsFromCache,
  updateCourseBookmarkStatusInCache,
} from "Course/modules/CourseGraphqlHelpers";
import { getUserCoursesFiltersV2 } from "Course/modules/CourseModule";
import { updateCourseBookmarkMutation } from "Courses/modules/CoursesMutations";
import { AVATAR_COLORS } from "Constants/colorConstants";
import {
  goToAdminRoute,
  goToPlatformHomeFeatureRoute,
  goToPlatformHomeChildRoute,
} from "modules/NavigationModule";
import { getCurrentPathname } from "services/NavigationService";
import { replaceLabelKeysWithValue } from "Utils";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  SUBJECT_TYPE_EE,
  SUBJECT_TYPE_CAS,
  SUBJECT_TYPE_TOK,
  SUBJECT_TYPE_LD,
  SUBJECT_TYPE_RP,
  SUBJECT_TYPE_PPS,
  SUBJECT_TYPE_SLR,
  SUBJECT_TYPE_CE,
  ANNOUNCEMENT,
} from "Constants/stringConstants";
import { MY_CALENDAR_CONSTANTS } from "MyCalendar/constants/stringConstants";
import ACLStore from "lib/aclStore";
import {
  getUserCourseTagsFilters,
  getLastSelectedTab,
} from "Courses/modules/utils";
import { getLTIName } from "LTIComponent/modules/Utils";
import { goToRelativeRoute } from "modules/Services";
import { getTodaysDate } from "Utils/DateTimeHelpers";
import { hasModuleAccess } from "lib/staffPermissionUtils";
import { recordEvent } from "lib/eventTracker";
import {
  ENABLE_ASSESSMENTS_IN_PYP,
  IS_GRADEBOOK_TABS_NAVIGATION_ENABLED,
  CAN_VIEW_LTI_TOOLS_CONFIG,
  CAN_VIEW_LTI_TOOLS,
  USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
} from "Constants/permissionConstants";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";
import ACLStorage from "lib/aclService";
import {
  getIsConfigurationEnabledForCPAY,
  getSettingValue,
} from "modules/PermissionModule";
import { getIsLearningCoursesEnabled } from "Teacher/routes/LearningCourses/modules/Utils";
import { QuickTaskOutlined } from "@toddle-edu/ds-icons";
import { getIsCoursePlanRouteEnabled } from "Utils/ACLStoreUtils";
import {
  getSortedOptions,
  getLtiToolIcon,
} from "Teacher/routes/LearningCourse/modules/SidebarUtils";
import { Badge } from "@toddle-edu/ds-web";

// ------------------------------------
// Constants
// ------------------------------------

export const NAME = "teacher";

export const CHANGE_DRAWER_STATE = "CHANGE_DRAWER_STATE" + " " + NAME;

export const SET_DASHBOARD_COACHMARK_VISIBILITY =
  "SET_DASHBOARD_COACHMARK_VISIBILITY" + " " + NAME;

export const SET_NOTIFICATION_COUNT = "SET_NOTIFICATION_COUNT" + " " + NAME;

export const SET_GRADE_GROUPS = "SET_GRADE_GROUPS" + " " + NAME;

export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB" + " " + NAME;

export const TOGGLE_DAILY_CALENDAR_STATE =
  "TOGGLE_DAILY_CALENDAR_STATE" + " " + NAME;

export const TOGGLE_NOTIFICATION_CENTER_STATE =
  "TOGGLE_NOTIFICATION_CENTER_STATE" + " " + NAME;

export const SET_HOMEPAGE_SIDEBAR = "SET_HOMEPAGE_SIDEBAR" + " " + NAME;

export const UPDATE_WIDGET_FILTERS = "UPDATE_WIDGET_FILTERS" + " " + NAME;

export const ON_USER_COMMUNICATION_MODAL_CLOSE = `ON_USER_COMMUNICATION_MODAL_CLOSE ${NAME}`;

export const ON_USER_COMMUNICATION_ENUM_SELECT = `ON_USER_COMMUNICATION_ENUM_SELECT ${NAME}`;

export const SET_MAX_SCORE_VALUE = "SET_MAX_SCORE_VALUE" + " " + NAME;

export const UPDATE_SHOW_NEXT_UPCOMING_DEADLINES = `UPDATE_SHOW_NEXT_UPCOMING_DEADLINES ${NAME}`;

export const UPDATE_SHOW_FINAL_MESSAGE_FOR_UPCOMING_DEADLINES = `UPDATE_SHOW_FINAL_MESSAGE_FOR_UPCOMING_DEADLINES ${NAME}`;

const SUBJECT_LEVEL = "SUBJECT_LEVEL";

const CLASS_ANNOUNCEMENT_FEATURE_FLAG = "FeatureFlag:ClassAnnouncement";

//PURE ACTIONS

export const updateWidgetFiltersObj = data => {
  return {
    type: UPDATE_WIDGET_FILTERS,
    payload: data,
  };
};

export const toggleDailyCalendarState = data => {
  return { type: TOGGLE_DAILY_CALENDAR_STATE };
};

export const setHomePageSidebar = data => {
  return { type: SET_HOMEPAGE_SIDEBAR, data };
};

export const setNotificationCount = data => {
  return { type: SET_NOTIFICATION_COUNT, data };
};

export const setActiveTabValue = data => {
  return { type: SET_ACTIVE_TAB, payload: data };
};

export const setGradeGroups = data => {
  return { type: SET_GRADE_GROUPS, data: data };
};

export const onUserCommunicationModalClose = data => {
  return { type: ON_USER_COMMUNICATION_MODAL_CLOSE, payload: data };
};

export const onUserCommunicationEnumSelect = data => {
  return { type: ON_USER_COMMUNICATION_ENUM_SELECT, payload: data };
};

export const resetGradeGroups = () => {
  return (dispatch, getState) =>
    dispatch(
      setGradeGroups({
        selected_grades: null,
        selected_course: "",
        isDemo: false,
        isArchivedClass: false,
      })
    );
};

export const setDashboardCoachmarkVisibility = payload => {
  return { type: SET_DASHBOARD_COACHMARK_VISIBILITY, payload };
};

export const setMaxScoreValue = value => {
  return { type: SET_MAX_SCORE_VALUE, value };
};

export const getTeacherNode = id => {
  const nodes = _.get(TeacherMenu, "nodes", []);
  return _.find(nodes, item => item.id == id);
};

export const getUserIdAndEntityTypeByUserMemoize = _.memoize(
  ({ userInfo }) => {
    return {
      //in case of parent as user we need to fetch the courses of selected student so we are passing student id in userId
      userId: userInfo.user_type == "parent" ? userInfo.childID : userInfo.id,
      userEntityType:
        userInfo.user_type == "parent" ? "STUDENT" : userInfo.userEntityType,
    };
  },
  ({ userInfo }) =>
    JSON.stringify({
      userType: userInfo.user_type,
      userId: userInfo.id,
      childID: userInfo.childID,
      entityType: userInfo.userEntityType,
    })
);

export const updateShowNextUpcomingDeadlines = data => {
  return {
    type: UPDATE_SHOW_NEXT_UPCOMING_DEADLINES,
    data,
  };
};

export const updateShowFinalMessageForUpcomingDeadlines = data => {
  return {
    type: UPDATE_SHOW_FINAL_MESSAGE_FOR_UPCOMING_DEADLINES,
    data,
  };
};

const getDPRootNodeName = ({ user_type, subjectType }) => {
  if (user_type === "staff") {
    switch (subjectType) {
      case SUBJECT_TYPE_CAS:
        return "teacherPortalIBDPCASRootNodes";
      case SUBJECT_TYPE_TOK:
        return "teacherPortalIBDPTOKRootNodes";
      case SUBJECT_TYPE_EE:
        return "teacherPortalIBDPEERootNodes";
      case SUBJECT_TYPE_LD:
        return "teacherPortalIBDPLDRootNodes";
      case SUBJECT_TYPE_PPS:
        return "teacherPortalIBDPPPSRootNodes";
      case SUBJECT_TYPE_RP:
        return "teacherPortalIBDPRPRootNodes";
      case SUBJECT_TYPE_SLR:
        return "teacherPortalIBDPSLRRootNodes";
      case SUBJECT_TYPE_CE:
        return "teacherPortalIBDPCERootNodes";
    }

    return "teacherPortalIBDPRootNodes";
  } else if (user_type === "student") {
    switch (subjectType) {
      case SUBJECT_TYPE_CAS:
        return "studentPortalIBDPCASRootNodes";
      case SUBJECT_TYPE_TOK:
        return "studentPortalIBDPTOKRootNodes";
      case SUBJECT_TYPE_EE:
        return "studentPortalIBDPEERootNodes";
      case SUBJECT_TYPE_LD:
        return "teacherPortalIBDPLDRootNodes";
      case SUBJECT_TYPE_PPS:
        return "teacherPortalIBDPPPSRootNodes";
      case SUBJECT_TYPE_RP:
        return "teacherPortalIBDPRPRootNodes";
      case SUBJECT_TYPE_SLR:
        return "teacherPortalIBDPSLRRootNodes";
      case SUBJECT_TYPE_CE:
        return "teacherPortalIBDPCERootNodes";
    }

    return "studentPortalIBDPRootNodes";
  } else if (user_type === "parent") {
    return "parentPortalIBDPRootNodes";
  }

  return null;
};

//it will return the first node from the calculated navigation menu
const getFallbackDefaultNode = ({ menuList }) => {
  const menuItem = _.first(menuList);
  if (_.size(_.get(menuItem, "children", [])) > 0) {
    return getFallbackDefaultNode({ menuList: menuItem.children });
  } else {
    return menuItem?.id;
  }
};

//get the default tab to navigate from the teacher menu based on user and curriculum
export const getDefaultSelectedNodeId = ({
  curriculumType,
  user_type,
  isCoreCourse,
}) => {
  return (dispatch, getState) => {
    const {
      defaultTeacherNodeId,
      defaultPYPStudentNodeId,
      defaultMYPStudentNodeId,
      defaultParentNodeId,
      defaultUBDStudentNodeId,
    } = TeacherMenu;

    const { topMenuList = [], bottomMenuList = [] } = _.get(
      getState(),
      "course.navigationMenu",
      {}
    );

    let defaultNodeId = null;

    switch (user_type) {
      case "staff": {
        switch (true) {
          case CURRICULUM_TYPE_PYP === curriculumType:
          case CURRICULUM_TYPE_MYP === curriculumType:
          case CURRICULUM_TYPE_UBD === curriculumType:
          case CURRICULUM_TYPE_DP === curriculumType && !isCoreCourse:
            defaultNodeId = defaultTeacherNodeId;
            break;
        }
        break;
      }
      case "student": {
        switch (true) {
          case CURRICULUM_TYPE_PYP === curriculumType:
          case CURRICULUM_TYPE_DP === curriculumType && !isCoreCourse:
            defaultNodeId = defaultPYPStudentNodeId;
            break;
          case CURRICULUM_TYPE_MYP === curriculumType:
            defaultNodeId = defaultMYPStudentNodeId;
            break;
          case CURRICULUM_TYPE_UBD === curriculumType:
            defaultNodeId = defaultUBDStudentNodeId;
            break;
        }
        break;
      }
      case "parent": {
        defaultNodeId = defaultParentNodeId;
        break;
      }
    }

    return (
      defaultNodeId ||
      getFallbackDefaultNode({
        menuList: [...topMenuList, ...bottomMenuList],
      }) ||
      "UNIT_PLANS"
    );
  };
};

const getNodePermission = ({ node, user_type }) => {
  let perm = null;
  switch (user_type) {
    case "staff":
      perm = _.get(node, "perm", null);
      break;
    case "student":
      perm = _.get(node, "studentPerm", null);
      break;
    case "parent":
      perm = _.get(node, "parentPerm", null);
  }
  return perm;
};

export const DISABLE_ACADEMIC_YEAR_DEPENDENT_MENU_ITEMS = [
  "FAMILY_COMMUNICATIONS",
  "CLASS_PROGRESS_SUMMARY",
  "SETTINGS",
];

// List down all those nodes that are not available if working in a future academic year
export const FUTURE_ACADEMIC_YEAR_DISABLED_MENU_ITEMS = [
  "CLASSROOM",
  "UBD_CLASS",
  "CLASS_PROGRESS",
  "GRADEBOOK",
  "PROJECT_GROUP",
  "SETTINGS",
  "SUBJECT_SETTINGS",
];

export const OLD_EDUCATOR_CENTER_MENU_ITEMS = [
  "TEACHER_SCHOOL_POLICIES",
  "PARENT_SCHOOL_POLICIES",
  "STUDENT_SCHOOL_POLICIES",
  "FAMILY_PORTAL_SCHOOL_POLICIES",
  "TEACHER_RESOURCE",
  "STUDENT_RESOURCE",
  "PARENT_RESOURCE",
];

/**
 * use this fn to give value to your dynamic route
 * This fn will be useful to you when you have dynamic routes in TeacherMenu's nodes property
 * for ex. we have node like below in nodes array of TeacherMenu
 *
 * {
      id: "CAS_PROJECT",
      label: "cas",
      isBottom: false,
      children: [],
      route: "projects/:projectGroupId",
      levelId: "L1",
      icon: <StudentPortfolioSvg />,
      perm: "Common:CASProjects",
      studentPerm: "Common:CASProjects",
    },
 * So here you can see that in the route we have "projects/:projectGroupId" so here projectGroupId is dynamic
 * So to replace that projectGroupId with its actual value this fn will be useful


 *  when to use ?
 * ->  whenever you are using route property of node(from nodes array of TeacherMenu) before using node just
 pre-process nodes first by this fn.
 *
 *
 *  How to use ?
 * ->  You have to just give nodes from TeacherMenu and the dynamicRouteParams which is an object of all the
 * dynamic Parameter's value.
 * Eg. for above example dynamicRouteParams will be { CAS_PROJECT:{ projectGroupId:100 }}. so here key "CAS_PROJECT" is the
 * id of node for which we want to replace dynamic routes and value for key "CAS_PROJECT" is its all dynamic params in the route.
 * Here we have only one "projectGroupId". But if you have route property in node is like "projects/:projectGroupId/progress/:projectId" then in
 * that case dynamicRouteParams object will look like { CAS_PROJECT:{ projectGroupId:100 ,projectId: 200}}.
 *
 * NOTE: Just make sure that you give key value pair in dynamicRouteParams object such that the key should be the id of node
 * for which you want to pre-process route property (in above example "CAS_PROJECT") and the value should be an object of dynamic params
 * with name of dynamic param and its value(for above ex { projectGroupId:100} will be the object here projectGroupId is our dynamic param).
 */

const getIconProjectGroup = ({ subType, iconConfig, node }) => {
  return (
    _.get(_.find(iconConfig, { type: subType }), "icon", null) ||
    _.get(node, "icon", null)
  );
};

const getDynamicMenuItems = ({
  isLocked,
  node,
  params = {},
  unreadAnnouncementsCount = 0,
  user_type,
}) => {
  const isDynamicNode = _.get(node, "isDynamicNode", false);

  if (isDynamicNode) {
    const {
      dynamicNodeConfig: { type = "", id = "", iconConfig = [] } = {},
      label,
    } = node;

    switch (type) {
      case "PROJECT_GROUP": {
        const { courseProjectGroups } = params;
        const menuItems = [];

        _.forEach(courseProjectGroups, courseProjectGroup => {
          menuItems.push({
            ...node,
            id: replaceLabelKeysWithValue({
              label: id,
              key: "projectGroupType",
              value: courseProjectGroup.type,
            }),
            label: replaceLabelKeysWithValue({
              label,
              key: "projectGroupType",
              value: courseProjectGroup.name,
            }),
            route: `projects/${courseProjectGroup.id}`,
            isLocked,
            children: [],
            icon: getIconProjectGroup({
              iconConfig,
              subType: _.get(courseProjectGroup, "subType", null),
              node,
            }),
            projectType: _.get(courseProjectGroup, "subType", null),
          });
        });

        return menuItems;
      }
      case "PRACTICAL_ACTIVITIES": {
        const subjects = _.get(params, "subjects", []);
        const isPsow = _.get(subjects, "[0].metadata.isPsow", false);
        const isESAS = _.get(subjects, "[0].metadata.isESAS", false);
        const menuItems = [];

        if (isPsow || isESAS) {
          menuItems.push({
            ...node,
            id: "PRACTICAL_ACTIVITIES",
            label: "project:practical_PSOW",
            route: "practicalactivities",
            isLocked,
            children: [],
          });
        }
        return menuItems;
      }
      case "RECORD_OF_EXPERIMENTAL_PROGRAMMES": {
        const subjects = _.get(params, "subjects", []);
        const isRoep = _.get(subjects, "[0].metadata.isRoep", false);
        const menuItems = [];
        if (isRoep) {
          menuItems.push({
            ...node,
            id: "RECORD_OF_EXPERIMENTAL_PROGRAMMES",
            label: "project:ROEP",
            route: "recordofexperimentalprogrammes",
            isLocked,
            children: [],
          });
        }
        return menuItems;
      }
      case "CLASS_SETTINGS": {
        const { dynamicNodeConfig, label } = node;
        const labelConfig = _.get(dynamicNodeConfig, "labelConfig");
        const { curriculumType } = params;
        const menuItems = [];
        menuItems.push({
          ...node,
          label: labelConfig[curriculumType] || label,
          isLocked,
          children: [],
        });
        return menuItems;
      }
    }
  }

  // Add badge count for announcement
  if (node.id === "ANNOUNCEMENT") {
    const menuItems = [];
    menuItems.push({
      ...node,
      icon: (
        <span>
          <Badge
            dsVersion="2.0"
            containerStyle={{
              display: "flex",
            }}
            offset={[4, 4]}
            type="numeric"
            size="xxx-small"
            value={unreadAnnouncementsCount}
          >
            <QuickTaskOutlined variant={user_type !== "staff" ? "on" : "off"} />
          </Badge>
        </span>
      ),
      isLocked,
      children: [],
    });
    return menuItems;
  }

  return [{ ...node, isLocked, children: [] }];
};

// returns curriculumDPCoreChildren if it exists else returns curriculumDPChildren
const getCurriculumDPChildren = ({
  currentNode,
  subjectType,
  curriculumId,
}) => {
  const coreSubjects = [SUBJECT_TYPE_CAS, SUBJECT_TYPE_EE, SUBJECT_TYPE_TOK];
  const isCoreSubject = _.includes(coreSubjects, subjectType);

  const allowedSubjectTypes = getSettingValue({
    name: "EnablePortfolioForDpCoreChild",
    currentCurriculumProgramId: curriculumId,
  });
  const currentNodes = _.clone(currentNode.curriculumDPCoreChildren);

  if (
    Array.isArray(currentNode.curriculumDPCoreChildren) &&
    _.isEqual(currentNode?.id, "CLASSROOM") &&
    _.includes(allowedSubjectTypes, subjectType) &&
    !_.includes(currentNodes, "DP_SUBJECT_JOURNAL")
  ) {
    currentNodes.push("DP_SUBJECT_JOURNAL");
  }
  if (
    currentNode?.curriculumDPCASOrEEChildren &&
    _.includes([SUBJECT_TYPE_CAS, SUBJECT_TYPE_EE], subjectType)
  ) {
    return currentNode.curriculumDPCASOrEEChildren;
  } else if (currentNode?.curriculumDPCoreChildren && isCoreSubject) {
    return currentNodes;
  } else {
    return currentNode.curriculumDPChildren;
  }
};

const getSortedMenuByDisplaySequence = ({
  options,
  userType,
  courseId,
  isBottom,
  isLearningCourseEnabled,
}) => {
  if (userType === "staff" || isBottom || !isLearningCourseEnabled)
    return options;

  const sortedMenu = getSortedOptions({
    options,
    userType,
    nodeType: "classNodes",
    classId: courseId,
  });

  return sortedMenu;
};

//this fn will give you menu for course you select and if you keep shouldReturnMenuRoutes true the it will return the
//routes of that menu items.
export const getMenu = ({
  isBottom,
  isCurriculumProgramFree,
  isDemoCourse,
  user_type,
  curriculumType,
  disabledMenuItems = [],
  courseProjectGroups,
  subjectType,
  plannerElementSets,
  subjects,
  curriculumId,
  ltiDropDownOptions,
  isSentralESFEnabledOrg,
  isESFMasterClassEnabled,
  courseId,
  unreadAnnouncementsCount = 0,
  isCurriculumInsightsEnabled,
}) => {
  const activeMenu = [];

  if (isDemoCourse && !isCurriculumProgramFree) {
    return activeMenu;
  }
  let rootNodes = [];
  const nodes = _.get(TeacherMenu, "nodes", []);
  const allowedSubjectTypes = getSettingValue({
    name: "EnablePortfolioForDpCoreChild",
    currentCurriculumProgramId: curriculumId,
  });
  switch (user_type) {
    case "staff":
      if (isSentralESFEnabledOrg) {
        if (
          [
            CURRICULUM_TYPE_MYP,
            CURRICULUM_TYPE_UBD,
            CURRICULUM_TYPE_DP,
          ].includes(curriculumType)
        ) {
          const sentralNodeKey = isESFMasterClassEnabled
            ? "teacherPortalESFMasterClassRootNodes"
            : "teacherPortalESFNonMasterClassRootNodes";
          rootNodes = _.get(TeacherMenu, sentralNodeKey, []);
        } else {
          rootNodes = isCurriculumProgramFree
            ? _.get(TeacherMenu, "teacherPoralIBPYPFreemiumRootNodes", [])
            : _.get(TeacherMenu, "teacherPortalIBPYPRootNodes", []);
        }
      } else if (curriculumType === CURRICULUM_TYPE_MYP) {
        rootNodes = _.get(TeacherMenu, "teacherPortalIBMYPRootNodes", []);
      } else if (curriculumType === CURRICULUM_TYPE_UBD) {
        rootNodes = _.get(TeacherMenu, "teacherPortalUBDRootNodes", []);
      } else if (curriculumType === CURRICULUM_TYPE_DP) {
        const nodeName = getDPRootNodeName({ user_type, subjectType });
        rootNodes = _.get(TeacherMenu, nodeName, []);
      } else {
        rootNodes = isCurriculumProgramFree
          ? _.get(TeacherMenu, "teacherPoralIBPYPFreemiumRootNodes", [])
          : _.get(TeacherMenu, "teacherPortalIBPYPRootNodes", []);
      }

      break;
    case "student":
      if (curriculumType === CURRICULUM_TYPE_PYP) {
        rootNodes = _.get(TeacherMenu, "studentPortalIBPYPRootNodes", []);
      } else if (curriculumType === CURRICULUM_TYPE_MYP) {
        rootNodes = _.get(TeacherMenu, "studentPortalIBMYPRootNodes", []);
      } else if (curriculumType === CURRICULUM_TYPE_UBD) {
        rootNodes = _.get(TeacherMenu, "studentPortalUBDRootNodes", []);
      } else if (curriculumType === CURRICULUM_TYPE_DP) {
        const nodeName = getDPRootNodeName({ user_type, subjectType });
        rootNodes = _.get(TeacherMenu, nodeName, []);

        if (
          _.includes(allowedSubjectTypes, subjectType) &&
          !_.includes(rootNodes, "DP_SUBJECT_JOURNAL")
        ) {
          rootNodes.push("DP_SUBJECT_JOURNAL");
        }
      } else {
        rootNodes = _.get(TeacherMenu, "studentPortalIBPYPRootNodes", []);
      }

      break;
    case "parent":
      if (curriculumType === CURRICULUM_TYPE_PYP) {
        rootNodes = _.get(TeacherMenu, "parentPortalIBPYPRootNodes", []);
      } else if (curriculumType === CURRICULUM_TYPE_UBD) {
        rootNodes = _.get(TeacherMenu, "parentPortalUBDRootNodes", []);
      } else if (curriculumType === CURRICULUM_TYPE_MYP) {
        rootNodes = _.get(TeacherMenu, "parentPortalIBMYPRootNodes", []);
      } else if (curriculumType === CURRICULUM_TYPE_DP) {
        const nodeName = getDPRootNodeName({ user_type, subjectType });
        rootNodes = _.get(TeacherMenu, nodeName, []);
        if (
          _.get(subjects, "0.subjectGroup.type") === "CORE" &&
          !_.includes(allowedSubjectTypes, subjectType) &&
          _.includes(rootNodes, "DP_SUBJECT_JOURNAL")
        ) {
          rootNodes = _.filter(
            rootNodes,
            item => item !== "DP_SUBJECT_JOURNAL"
          );
        }
      } else {
        rootNodes = _.get(TeacherMenu, "parentPortalIBPYPRootNodes", []);
      }

      break;
  }

  if (
    getIsConfigurationEnabledForCPAY({
      configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
    })
  ) {
    rootNodes = _.filter(
      rootNodes,
      rootNodeId => rootNodeId !== "PROGRESS_REPORT_V2"
    );
  }

  if (ACLStore.can("FeatureFlag:EnableNewClassSidebar")) {
    rootNodes = _.filter(rootNodes, rootNodeId => {
      if (rootNodeId === "CLASS_PROGRESS") return false;

      if (
        getIsConfigurationEnabledForCPAY({
          configuration: IS_GRADEBOOK_TABS_NAVIGATION_ENABLED,
        })
      ) {
        return rootNodeId !== "GRADEBOOK_V2";
      } else {
        return !_.includes(["GRADEBOOK", "GRADEBOOK_CAS"], rootNodeId);
      }
    });
  }

  const isLearningCourseEnabled = getIsLearningCoursesEnabled({
    curriculumProgramId: curriculumId,
  });

  _.forEach(rootNodes, rootNodeId => {
    const currentNode = _.find(
      nodes,
      node =>
        node.id == rootNodeId &&
        (node.isBottom || false) == isBottom &&
        !disabledMenuItems.includes(node.id)
    );

    if (currentNode) {
      const children = [];

      let isLocked = true;
      let nodeChildren = [];

      if (curriculumType === CURRICULUM_TYPE_MYP) {
        nodeChildren = currentNode.curriculumIBMYPChildren;
      } else if (curriculumType === CURRICULUM_TYPE_UBD) {
        nodeChildren = currentNode.curriculumUBDChildren;
      } else if (curriculumType === CURRICULUM_TYPE_DP) {
        nodeChildren = getCurriculumDPChildren({
          currentNode,
          subjectType,
          curriculumId,
        });
      } else {
        nodeChildren = currentNode.children;
      }

      // if (currentNode.id === "LTI_TOOLS") {
      //   nodeChildren = _.filter(currentNode.children, child =>
      //     _.includes(_.map(ltiDropDownOptions, "serviceName"), child)
      //   );
      // }

      //  -------------------------------------------->

      if (currentNode.id === "LTI_TOOLS" && Array.isArray(ltiDropDownOptions)) {
        // 1. Find the LTI_TOOLS node in the menu
        const ltiNode = _.find(TeacherMenu.nodes, { id: "LTI_TOOLS" });

        if (ltiNode) {
          // 2. Get current LTI tool IDs from the options
          const currentLtiToolIds = _.map(ltiDropDownOptions, tool =>
            tool.serviceName.toUpperCase()
          );

          // 3. Find existing LTI tool nodes in the menu
          const existingLtiToolNodes = _.filter(
            TeacherMenu.nodes,
            node => node.type === "LTI_TOOL"
          );

          // 4. Remove tools that are no longer in the options
          _.forEach(existingLtiToolNodes, node => {
            if (!_.includes(currentLtiToolIds, node.id)) {
              // Remove from nodes array
              _.remove(TeacherMenu.nodes, { id: node.id });

              // Remove from LTI_TOOLS children array
              _.remove(ltiNode.children, id => id === node.id);
            }
          });

          // 5. Add or update tools from the options
          _.forEach(ltiDropDownOptions, ltiTool => {
            const toolId = ltiTool.name
              ? ltiTool.name.toUpperCase()
              : ltiTool.serviceName.toUpperCase();
            const childrenNode = {
              id: toolId,
              type: "LTI_TOOL",
              label:
                ltiTool.name ||
                getLTIName(ltiTool.serviceName) ||
                ltiTool.serviceName,
              levelId: "L1",
              route: `lti-tools/${encodeURIComponent(
                (ltiTool.name || ltiTool.serviceName).toLowerCase()
              )}`,
              icon: getLtiToolIcon(ltiTool.serviceName, ltiTool.name),
              studentPerm: CAN_VIEW_LTI_TOOLS_CONFIG,
              perm: CAN_VIEW_LTI_TOOLS, // we have added permission for teacher as well because for toddle 1.0 we can not toggle this flag and default value of this flag is true
              isBottom: false,
            };

            // Check if this tool already exists in the menu
            const existingNode = _.find(TeacherMenu.nodes, { id: toolId });

            if (existingNode) {
              // Update existing node (in case name changed)
              existingNode.label = childrenNode.label;
              existingNode.route = childrenNode.route;
            } else {
              // Add new node
              TeacherMenu.nodes.push(childrenNode);

              // Add to LTI_TOOLS children if not already there
              if (!_.includes(ltiNode.children, toolId)) {
                ltiNode.children.push(toolId);
              }
            }
          });

          // 6. If no LTI tools, you might want to hide the LTI_TOOLS menu item
          if (ltiDropDownOptions.length === 0) {
            // Option 1: Hide the LTI_TOOLS node
            // _.remove(TeacherMenu.nodes, { id: "LTI_TOOLS" });

            // Option 2: Or just clear its children
            ltiNode.children = [];
          }
        }
      }

      //  -------------------------------------------->

      if (_.size(nodeChildren) > 0) {
        _.forEach(nodeChildren, childId => {
          let childNode = _.find(
            nodes,
            node => node.id == childId && !disabledMenuItems.includes(childId)
          );

          //Temp : Later yearly planning in PYP It will be deprecated completely
          if (childId == "SCHEDULER") {
            childNode = {
              ...childNode,

              label: ACLStore.can("TeacherPortal:EnableYearlySchedulerInPYP")
                ? "teacherHomePage:weekly_yearly_planning"
                : "teacherHomePage:weekly_planning",
            };
          }

          // change label if assessments enabled for PYP
          if (
            childId == "LE_LIBRARY_PYP" &&
            ACLStore.can(ENABLE_ASSESSMENTS_IN_PYP)
          ) {
            childNode = {
              ...childNode,
              label:
                "teacherHomePage:learning_experience_&_assessment_library_sentence_case",
            };
          }

          // subject standards is disabled for CP_CORE
          if (childId == "DP_SUBJECT_STANDARD") {
            if (_.includes([SUBJECT_TYPE_LD, SUBJECT_TYPE_PPS], subjectType))
              return;
          }

          // planning insights is superseded by curriculum insights
          if (
            _.includes(["PLANNING_INSIGHTS", "DP_PLANNING_INSIGHTS"], childId)
          ) {
            if (isCurriculumInsightsEnabled) {
              return;
            }
          }

          if (childNode?.dynamicPlannerElementLabelPerm) {
            const isDynamicPlannerElementLabel = ACLStore.can(
              childNode.dynamicPlannerElementLabelPerm
            );

            if (isDynamicPlannerElementLabel) {
              childNode = {
                ...childNode,
                label: plannerElementSets[childNode.plannerElementType].label,
                isLabelNotLocalized: isDynamicPlannerElementLabel,
              };
            }
          }

          const perm = getNodePermission({ node: childNode, user_type });

          if (
            childNode &&
            perm &&
            ACLStore.can(perm, "all") &&
            hasModuleAccess(childNode, curriculumId) &&
            childNode.type !== "LTI_TOOL"
          ) {
            const isChildLock = ACLStore.isLocked(perm);
            const menuItems = getDynamicMenuItems({
              isLocked: isChildLock,
              node: childNode,
              params: { courseProjectGroups, subjects, curriculumType },
            });
            children.push(...menuItems);
          }

          const hasLTIPermission =
            user_type === "staff"
              ? ACLStorage.getModuleSettingsValue(perm)
              : ACLStore.can(perm, "all");

          if (
            childNode &&
            user_type !== "parent" &&
            perm &&
            hasLTIPermission &&
            childNode.type === "LTI_TOOL"
          ) {
            const menuItems = getDynamicMenuItems({
              isLocked: false,
              node: childNode,
              params: { courseProjectGroups, subjects, curriculumType },
            });
            children.push(...menuItems);
          }

          // Check if the node has permission based on roles and permissions architecture
          const permission = _.get(childNode, "permission", "");
          if (permission && ACLStorage.getModuleSettingsValue(permission)) {
            const isWeeklyPlanning = _.isEqual(
              permission,
              "Module:WeeklyPlanning"
            );
            const isWeeklyPlanners = _.isEqual(
              permission,
              "Module:WeeklyPlanners"
            );
            const canAccess =
              (isWeeklyPlanning && ACLStore.can("TeacherPortal:Scheduler")) ||
              (isWeeklyPlanners && ACLStore.can("Common:ClassPlanners"));

            if ((!isWeeklyPlanning && !isWeeklyPlanners) || canAccess) {
              const menuItems = getDynamicMenuItems({
                isLocked: false,
                node: childNode,
                params: { courseProjectGroups, subjects, curriculumType },
              });
              children.push(...menuItems);
            }
          }
        });
        if (_.size(children) > 0) {
          // if there is only one child then directly add it to the root node
          if (_.size(children) === 1) {
            activeMenu.push(_.first(children));
          } else {
            activeMenu.push({ ...currentNode, children });
          }
        }
      } else {
        const perm = getNodePermission({ node: currentNode, user_type });

        const currentNodeId = currentNode.id;

        let skipNode = false;

        // Class materials and course flow are on same permission but they never be shown together
        // In case of learning course, class materials will be shown
        // In case of non-learning course, course flow will be shown
        // Furthur permission will be checked
        if (
          currentNodeId === "COURSE_FLOW" ||
          currentNodeId === "COURSE_PLAN" ||
          currentNodeId === "CLASS_MATERIALS" ||
          currentNodeId === "UNIT_PLANS"
        ) {
          const isCoursePlanRouteEnabled = getIsCoursePlanRouteEnabled();

          if (isLearningCourseEnabled) {
            skipNode =
              currentNodeId === "CLASS_MATERIALS" ||
              currentNodeId === "UNIT_PLANS" ||
              (isCoursePlanRouteEnabled
                ? currentNodeId === "COURSE_FLOW"
                : currentNodeId === "COURSE_PLAN");
          } else {
            skipNode =
              currentNodeId === "COURSE_FLOW" ||
              currentNodeId === "COURSE_PLAN";
          }
        }

        // LTI_TOOLS uses module settings (not ACLStore) for staff and has its own block below — exclude it here to avoid double-rendering.
        if (
          !skipNode &&
          perm &&
          ACLStore.can(perm, "all") &&
          hasModuleAccess(currentNode, curriculumId) &&
          currentNodeId !== "LTI_TOOLS"
        ) {
          isLocked = ACLStore.isLocked(perm);
          const menuItems = getDynamicMenuItems({
            isLocked,
            node: currentNode,
            params: { courseProjectGroups, subjects, curriculumType },
          });

          activeMenu.push(...menuItems);
        }

        // Check if the node has permission based on roles and permissions architecture
        const permission = _.get(currentNode, "permission", "");
        if (
          !skipNode &&
          permission &&
          ACLStorage.getModuleSettingsValue(permission)
        ) {
          const menuItems = getDynamicMenuItems({
            isLocked: false,
            node: currentNode,
            params: { courseProjectGroups, subjects, curriculumType },
            unreadAnnouncementsCount,
            user_type,
          });

          activeMenu.push(...menuItems);
        }

        // pushing lti node in classroom flow

        const hasLTIPermission =
          user_type === "staff"
            ? ACLStorage.getModuleSettingsValue(perm)
            : ACLStore.can(perm, "all");

        if (
          user_type !== "parent" &&
          currentNodeId === "LTI_TOOLS" &&
          perm &&
          hasLTIPermission &&
          !_.isEmpty(currentNode.children)
        ) {
          const children = _.chain(currentNode.children)
            .map(childId =>
              _.find(
                nodes,
                node =>
                  node.id == childId && !disabledMenuItems.includes(childId)
              )
            )
            .compact()
            .flatMap(childNode =>
              getDynamicMenuItems({
                isLocked: false,
                node: childNode,
                params: { courseProjectGroups, subjects, curriculumType },
              })
            )
            .value();

          if (!_.isEmpty(children)) {
            activeMenu.push(
              children.length === 1
                ? _.first(children)
                : { ...currentNode, children }
            );
          }
        }
      }
    }
  });

  const sortedActiveMenu = getSortedMenuByDisplaySequence({
    options: activeMenu,
    userType: user_type,
    courseId,
    isBottom,
    isLearningCourseEnabled,
  });

  return sortedActiveMenu;
};

const getMenuListRoutes = ({ routeList, menuList }) => {
  _.forEach(menuList, menu => {
    if (_.size(_.get(menu, "children", [])) > 0) {
      getMenuListRoutes({ routeList, menuList: menu.children });
    } else {
      const route = _.get(menu, "route");
      routeList.push(route);
    }
  });

  return routeList;
};

export const checkActiveTabRouteForCurrentMenuList = ({ currentActiveTab }) => {
  return (dispatch, getState) => {
    const { topMenuList = [], bottomMenuList = [] } = _.get(
      getState(),
      "course.navigationMenu",
      {}
    );

    const routeList = [];
    const menuList = [...topMenuList, ...bottomMenuList];
    getMenuListRoutes({ routeList, menuList });

    return _.includes(routeList, currentActiveTab);
  };
};

export const getDefaultRoute = ({
  user_type,
  defaultNodeId,
  userLastSelectedTab,
}) => {
  return (dispatch, getState) => {
    const { topMenuList = [], bottomMenuList = [] } = _.get(
      getState(),
      "course.navigationMenu",
      {}
    );

    let node = {};
    const getDefaultNode = ({ menuList }) => {
      _.forEach(menuList, menu => {
        if (_.size(_.get(menu, "children", [])) > 0) {
          getDefaultNode({ menuList: menu.children });
        } else if (
          menu.id === defaultNodeId &&
          ACLStore.can(getNodePermission({ node: menu, user_type }))
        ) {
          node = menu;
          return;
        }
      });
    };

    const menuList = [...topMenuList, ...bottomMenuList];
    getDefaultNode({ menuList });

    const routeTab = dispatch(
      checkActiveTabRouteForCurrentMenuList({
        currentActiveTab: userLastSelectedTab,
      })
    );

    if (routeTab) {
      return userLastSelectedTab;
    } else {
      let defaultRoute = "unitPlans";

      const routeList = [];
      getMenuListRoutes({ routeList, menuList });
      if (!_.isEmpty(routeList)) defaultRoute = _.first(routeList);

      return _.get(node, "route", defaultRoute);
    }
  };
};

export const onClassSelect = (
  course_id,
  isDemo = false,
  sourceFrom = "platform"
) => {
  return (dispatch, getState) => {
    dispatch(
      goToRelativeRoute({
        route: `${course_id}`,
      })
    );
  };
};

export const setGradeSection = course_id => {
  return (dispatch, getState) => {
    const academicYearId = getSelectedAcademicYearId(getState());
    const courseGradeFilters = {
      academicYearId,
    };
    const selectedClass = getCourseDetailsFromCache({
      id: course_id,
      courseGradeFilters,
    });
    const param = {};
    param["selected_grades"] = _.map(selectedClass.grades, grade => grade.id);
    param["selected_course"] = selectedClass.id;
    param["isDemo"] = selectedClass.isDemo;
    param["isArchivedClass"] = selectedClass.isArchived;
    param["isRemovedCourseForLoggedInUser"] = _.get(
      getCourseDetailsFromCache({
        id: course_id,
        courseGradeFilters,
      }),
      "isRemovedCourseForLoggedInUser",
      false
    );
    param["primaryGrade"] = _.get(selectedClass, "primaryGrade", {});
    param["learningCourse"] = _.first(
      _.get(selectedClass, "learningCourse", [])
    );

    dispatch(setGradeGroups(param));
  };
};

export const setActiveTab = route => {
  return (dispatch, getState) => {
    const node = getTeacherNodeByRouteName(route);
    dispatch(
      setCurrentPageTitle({
        from: "courses",
        label: _.get(node, "label", ""),
      })
    );
    const perm = _.get(node, "perm", "");
    dispatch(setActiveTabValue(route));
  };
};

export const setActiveHomepageCard = ({ from, label, isLocalized }) => {
  return (dispatch, getState) => {
    dispatch(
      setCurrentPageTitle({
        from,
        label,
        isLocalized,
      })
    );
  };
};

const getUpdatedNodes = ({ nodes }) => {
  return _.map(nodes, node => {
    if (node.dynamicPlannerElementLabelPerm) {
      return {
        ...node,
        isDynamicPlannerElementLabel: ACLStore.can(
          node.dynamicPlannerElementLabelPerm
        ),
      };
    }

    return node;
  });
};

export const getTeacherNodeByRouteName = route => {
  const nodes = getUpdatedNodes(TeacherMenu);
  return _.find(nodes, item => item.route == route);
};

export const doTransition = (value, courseId) => {
  return (dispatch, getState) => {
    const course_id = courseId
      ? courseId
      : getState().teacher.selected_class.selected_course;
    dispatch(setActiveTab(value));
    dispatch(
      goToPlatformHomeFeatureRoute({ courseId: course_id, route: `${value}` })
    );
  };
};

export const navigateToClassSelector = ({ type }) => {
  return (dispatch, getState) => {
    dispatch(
      goToPlatformHomeChildRoute({ route: "courses", navigateType: type })
    );
    dispatch(setGradeGroups({ isArchivedClass: false }));
  };
};

export const navigateToAdminPortal = () => {
  return (dispatch, getState) => {
    dispatch(goToAdminRoute());
  };
};

export const updateBookmarkCourse = courseIdInput => {
  return async dispatch => {
    const isBookmarkClicked = _.has(courseIdInput, "addCourseIds");
    const courseId = isBookmarkClicked
      ? _.first(_.get(courseIdInput, "addCourseIds", []))
      : _.first(_.get(courseIdInput, "removeCourseIds", []));

    try {
      const isUpdateDone = await client.mutate({
        mutation: updateCourseBookmarkMutation,
        variables: {
          input: courseIdInput,
        },
        optimisticResponse: {
          __typename: "Mutation",
          platform: {
            __typename: "PlatformMutations",
            updateCourseAsBookmark: true,
          },
        },
        update: (
          cache,
          {
            data: {
              platform: { updateCourseAsBookmark },
            },
          }
        ) => {
          if (updateCourseAsBookmark) {
            updateCourseBookmarkStatusInCache({
              courseId,
              isBookmark: isBookmarkClicked,
            });
          }
        },
      });
      return isUpdateDone;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

const getDisabledMenuItems = ({
  user_type,
  unitPlansCount,
  weeklyPlannerCount,
  studentFilesCount,
  assessmentEvaluationsCount,
  isLearningCourseEnabled,
}) => {
  const disabledMenuItems = [];
  switch (user_type) {
    case "student":
      if (unitPlansCount === 0) {
        disabledMenuItems.push("UNIT_PLANS");
      }
      if (isLearningCourseEnabled || studentFilesCount === 0) {
        disabledMenuItems.push("STUDENT_DRIVE");
      }
      if (!ACLStore.can(CLASS_ANNOUNCEMENT_FEATURE_FLAG)) {
        disabledMenuItems.push(ANNOUNCEMENT);
      }
      break;
    case "parent":
      if (unitPlansCount === 0) {
        disabledMenuItems.push("UNIT_PLANS");
      }
      if (weeklyPlannerCount === 0 && !isLearningCourseEnabled) {
        disabledMenuItems.push("CLASSPLANNERS");
      }
      if (!ACLStore.can(CLASS_ANNOUNCEMENT_FEATURE_FLAG)) {
        disabledMenuItems.push(ANNOUNCEMENT);
      }
      if (isLearningCourseEnabled || studentFilesCount === 0) {
        disabledMenuItems.push("STUDENT_DRIVE");
      }
      break;
    case "staff":
      if (
        assessmentEvaluationsCount === 0 &&
        ACLStore.can("FeatureFlag:HideAssessLearningForNewClasses")
      ) {
        disabledMenuItems.push("ASSESSMENT_EVALUATION");
      }
      if (!ACLStore.can(CLASS_ANNOUNCEMENT_FEATURE_FLAG)) {
        disabledMenuItems.push(ANNOUNCEMENT);
      }
      break;
    default:
      break;
  }
  return disabledMenuItems;
};

export const getDisabledMenuItemsMemoize = _.memoize(
  params => getDisabledMenuItems(params),
  params => JSON.stringify(params)
);

const getSubjectLevelsText = tags =>
  _.join(
    _.map(
      _.filter(tags, tag => tag.type === SUBJECT_LEVEL),
      tag => tag.label
    ),
    ","
  );

export const getSubjectLevelsTextMemoize = _.memoize(
  params => getSubjectLevelsText(params),
  params => JSON.stringify(params)
);

// Get the avatar colors from availableColors, also if currentColor matches with previousColor then change currentColor.
export const getAvatarColor = index => {
  const currentColorIndex = index % AVATAR_COLORS.length;
  return AVATAR_COLORS[currentColorIndex];
};

/*
Examples of dynamic routes:
  -> /platform/6085/courses/54038/projects/28089/progress
  -> /platform/6085/courses/54038/subject-settings/subjects/107462/assessment-categories

Examples of static routes:
  -> /platform/1875/courses/45481/unitPlans/cardView
  -> /platform/1875/courses/45481/attendance
*/
const isDynamicRoute = route => {
  const dynamicRegex = /^\/platform\/\d+\/courses\/\d+\/[a-zA-Z-]+(?:\/[a-zA-Z-]+)*\/\d+\//;
  const match = route.match(dynamicRegex);
  return match !== null;
};

export const switchToCourse = ({ userInfo, course, curriculumId }) => {
  return async (dispatch, getState) => {
    const currentPath = getCurrentPathname();
    const activeTab = _.get(getState(), "teacher.activeTab");
    const courseId = _.get(course, "id", "");

    const userId = _.get(userInfo, "id", "");
    const userType = _.get(userInfo, "user_type", "");
    const userEntityType = _.get(userInfo, "userEntityType", "");

    const curriculumType = _.get(
      course,
      "curriculumProgram.type",
      CURRICULUM_TYPE_PYP
    );

    const userLastSelectedTab = getLastSelectedTab({
      activeTab,
      userId,
      userEntityType,
    });

    if (currentPath) {
      const splittedPath = _.split(currentPath, /(?:courses\/)(\d+)/g);
      let newPath = "";

      // if dynamic id after courseId we redirect it to defaultNode based on user type
      const isDynamicPath = isDynamicRoute(currentPath);

      if (isDynamicPath) {
        const defaultNodeId = dispatch(
          getDefaultSelectedNodeId({
            user_type: userType,
            curriculumType,
            isCoreCourse: _.some(
              _.get(course, "subjectGroups", []),
              subjectGroup => subjectGroup.type === "CORE"
            ),
          })
        );

        const defaultRoutePath = dispatch(
          getDefaultRoute({
            user_type: userType,
            defaultNodeId,
            userLastSelectedTab,
          })
        );

        newPath = `${_.first(
          splittedPath
        )}courses/${courseId}/${defaultRoutePath}`;

        dispatch(
          goToRelativeRoute({
            route: newPath,
            type: "replace",
          })
        );
      } else {
        const routeTab = dispatch(
          checkActiveTabRouteForCurrentMenuList({
            currentActiveTab: activeTab,
          })
        );

        // if new selected course doesn't have tab in side navigation which is selected in previous course, then select first tab as active tab from side navigation menu for selected course
        if (routeTab) {
          newPath = `${_.first(splittedPath)}courses/${courseId}/${activeTab}`;
        } else {
          const defaultNodeId = dispatch(
            getDefaultSelectedNodeId({
              user_type: userType,
              curriculumType,
              isCoreCourse: _.some(
                _.get(course, "subjectGroups", []),
                subjectGroup => subjectGroup.type === "CORE"
              ),
            })
          );

          const defaultRoutePath = dispatch(
            getDefaultRoute({
              user_type: userType,
              defaultNodeId,
              userLastSelectedTab,
            })
          );

          newPath = `${_.first(
            splittedPath
          )}courses/${courseId}/${defaultRoutePath}`;
        }

        dispatch(
          goToRelativeRoute({
            route: newPath,
            type: "replace",
          })
        );
      }

      if (userType === "staff") {
        recordEvent({
          eventName: "Quick course switch",
          eventData: {
            fromPath: currentPath,
            toPath: newPath,
            curriculumId,
          },
        });
      }
    }
  };
};

export const upsertThirdPartyCustomValue = ({ input, userId, userType }) => {
  return async (dispatch, getState) => {
    try {
      dispatch(toggleActionLoading(true));

      const refetchQueries = [
        {
          query: getUserThirdPartyRedirectionConfigsQuery,
          variables: {
            id: userId,
            type: userType,
            filters: {},
          },
        },
      ];

      const response = await client.mutate({
        mutation: upsertUserFieldsMutation,
        variables: {
          input,
        },
        refetchQueries,
      });

      const isSuccess = _.get(
        response,
        "data.platform.upsertUserFields.isSuccess",
        false
      );
      return isSuccess;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    } finally {
      dispatch(toggleActionLoading(false));
    }
  };
};

const REDUCER_HANDLERS = {
  [CHANGE_DRAWER_STATE]: (state, action) => {
    return Object.assign({}, state, { isDrawerOpen: action.payload });
  },

  [SET_DASHBOARD_COACHMARK_VISIBILITY]: (state, action) => {
    return Object.assign({}, state, { showDashboardCoachmark: action.payload });
  },

  [SET_NOTIFICATION_COUNT]: (state, action) => {
    return update(state, { notification_count: { $set: action.data } });
  },
  [SET_GRADE_GROUPS]: (state, action) => {
    const params = action.data;

    Object.keys(params).map((key, index) => {
      state = update(state, {
        selected_class: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },

  [SET_ACTIVE_TAB]: (state, action) => {
    return Object.assign({}, state, { activeTab: action.payload });
  },

  [TOGGLE_DAILY_CALENDAR_STATE]: (state, action) => {
    return update(state, {
      isDailyCalendarOpen: { $set: !state.isDailyCalendarOpen },
      isNotificationCenterOpen: { $set: false },
    });
  },

  [TOGGLE_NOTIFICATION_CENTER_STATE]: (state, action) => {
    return update(state, {
      isNotificationCenterOpen: { $set: !state.isNotificationCenterOpen },
      isDailyCalendarOpen: { $set: false },
    });
  },

  [SET_HOMEPAGE_SIDEBAR]: (state, action) => {
    let showSidebar = _.get(action, "data.showSidebar", false);
    let contentType = _.get(action, "data.contentType", null);
    const oldContentType = _.get(state, "sidebarConfig.contentType", null);
    if (oldContentType === contentType) {
      showSidebar = false;
      contentType = null;
    }
    return update(state, {
      sidebarConfig: {
        $set: {
          showSidebar: showSidebar,
          contentType: contentType,
        },
      },
    });
  },
  [UPDATE_WIDGET_FILTERS]: (state, action) => {
    Object.keys(action.payload).map((key, index) => {
      state = update(state, {
        widgetFilters: { [key]: { $set: action.payload[key] } },
      });
    });
    return state;
  },
  [ON_USER_COMMUNICATION_MODAL_CLOSE]: (state, action) => {
    return update(state, {
      userPopupMessage: {
        $set: {
          selectedUserMessageEnum: null,
          allowMessagePopUpOpen: false,
        },
      },
    });
  },
  [ON_USER_COMMUNICATION_ENUM_SELECT]: (state, action) => {
    const { selectedUserMessageEnum } = action.payload;
    return update(state, {
      userPopupMessage: {
        $set: {
          selectedUserMessageEnum,
        },
      },
    });
  },
  [SET_MAX_SCORE_VALUE]: (state, action) => {
    const { value } = action;
    return update(state, { maxScore: { $set: value } });
  },
  [UPDATE_SHOW_NEXT_UPCOMING_DEADLINES]: (state, action) => {
    const showUpcomingDeadlines = action.data;
    return update(state, {
      showNextUpcomingDeadlines: {
        $set: showUpcomingDeadlines,
      },
    });
  },
  [UPDATE_SHOW_FINAL_MESSAGE_FOR_UPCOMING_DEADLINES]: (state, action) => {
    const showFinalMessageForUpcomingDeadlines = action.data;
    return update(state, {
      showFinalMessageForUpcomingDeadlines: {
        $set: showFinalMessageForUpcomingDeadlines,
      },
    });
  },
};

const initialState = {
  isDrawerOpen: false,
  showDashboardCoachmark: false,
  notification_count: 0,
  selected_class: {
    selected_grades: null,
    selected_course: "",
    isDemo: false,
  },
  showNextUpcomingDeadlines: false,
  showFinalMessageForUpcomingDeadlines: false,
  userPopupMessage: {
    selectedUserMessageEnum: null,
    // When user logs in, this true value will allow it to show any pending message modals
    // once the user closes the modal, this is set to false and no further dropdowns
    // are shown unless user explicitly clicks on something which opens the modal
    // In the explicit click case, selectedUserMessageEnum is set and used for showing the
    // message
    allowMessagePopUpOpen: true,
  },
  permissionGroups: {
    staff: [
      "Dashboards",
      "TeacherPortal",
      "AdminPortal",
      "FeatureFlag",
      "VisitorPortal",
    ],
    student: ["StudentPortal", "FeatureFlag"],
    parent: ["FamilyPortal"],
  },
  activeTab: null,
  isDailyCalendarOpen: false,
  isNotificationCenterOpen: false,
  widgetFilters: {
    activeWidgetTab: "UPCOMING",
    isFromWidget: true,
    startDate: getTodaysDate(),
    contentTypes: [
      MY_CALENDAR_CONSTANTS.ASSESSMENT,
      MY_CALENDAR_CONSTANTS.RECURRING_MEETING,
      MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR,
    ],
  },
  maxScore: "",
};

const getCourseFilters = ({
  currentCurriculumProgramId,
  organizationCurriculumPrograms,
  isCurrentAcademicYear,
  academicYear,
  userTags,
  user_type,
  curriculumProgramIds,
}) => {
  const courseFilters = {
    ...getUserCoursesFiltersV2({
      currentCurriculumProgramId,
      organizationCurriculumPrograms,
      curriculumProgramIds,
    }),
    ...(!isCurrentAcademicYear && { academicYear }),
    /**
     * #### Specifically done for maple bear like orgs
     * When we query for courses, we have a tags filter.
     * User can specify the regions which will return courses in particular region(s).
     * If the user is global, this function will return false (no filters),
     * else it'll return tags: [ID!]. (IDs being the ids of region)
     */
    ...getUserCourseTagsFilters({ userTags }),
  };

  if (
    _.includes(["student", "parent"], user_type) &&
    ACLStore.can("FeatureFlag:StudentArchivedClasses")
  ) {
    courseFilters["includeRemovedCoursesForStudent"] = true;
  }

  return courseFilters;
};

const getCourseFiltersMemoizeCacheGen = param =>
  JSON.stringify({
    currentCurriculumProgramId: param?.currentCurriculumProgramId,
    isCurrentAcademicYear: param?.isCurrentAcademicYear,
    academicYear: param?.academicYear,
    userTags: param?.userTags,
    user_type: param?.user_type,
    curriculumProgramIds: param?.curriculumProgramIds,
  });

export const getCourseFiltersMemoize = _.memoize(
  getCourseFilters,
  getCourseFiltersMemoizeCacheGen
);

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
